import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function Footer() {
  const { t } = useTranslation();
  const langs = t("footer.langs", { returnObjects: true }) as string[];

  const serviceLinks = [
    { labelKey: "footer.willDrafting", path: "/services" },
    { labelKey: "footer.trustFormation", path: "/services" },
    { labelKey: "footer.prenuptialAgreement", path: "/services" },
  ];
  const companyLinks = [
    { labelKey: "footer.aboutUs", path: "/about" },
    { labelKey: "footer.services", path: "/services" },
    { labelKey: "footer.faqs", path: "/faqs" },
    { labelKey: "footer.contact", path: "/contact" },
  ];
  const resourceLinks = [
    { labelKey: "footer.freeConsultation", path: "/contact" },
    { labelKey: "footer.privacy", path: "/" },
    { labelKey: "footer.disclaimer", path: "/" },
  ];

  return (
    <footer className="bg-[#1E202A] text-white">
      <div className="max-w-7xl mx-auto px-6 pt-16 pb-10">

        {/* Language strip */}
        <div className="pb-10 mb-10 border-b border-white/[0.08]">
          <p className="text-[10px] font-semibold uppercase tracking-widest text-white/30 mb-4">
            {t("footer.langAvailable")}
          </p>
          <div className="flex flex-wrap gap-x-8 gap-y-2">
            {Array.isArray(langs) && langs.map((l) => (
              <span key={l} className="text-white/50 text-xs tracking-wide">{l}</span>
            ))}
          </div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 pb-12 border-b border-white/[0.08]">
          {/* Left */}
          <div className="flex flex-col gap-6">
            <div>
              <span className="text-3xl text-white leading-none block" style={{ fontFamily: "'Great Vibes', cursive" }}>
                Wills &amp; Trusts
              </span>
              <span
                className="block mt-1 tracking-[0.18em] uppercase leading-none"
                style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: "9px", fontWeight: 600, color: "#B8942A", letterSpacing: "0.18em" }}
              >
                {t("brand.firmName")}
              </span>
              <p className="text-white/40 text-xs leading-relaxed mt-4 max-w-xs">{t("footer.desc")}</p>
            </div>
            <div className="flex gap-3">
              {[
                { icon: "ri-facebook-fill", href: "#" },
                { icon: "ri-linkedin-fill", href: "#" },
                { icon: "ri-instagram-line", href: "#" },
                { icon: "ri-kakao-talk-fill", href: "#" },
              ].map((s) => (
                <a
                  key={s.icon}
                  href={s.href}
                  rel="nofollow"
                  className="w-9 h-9 flex items-center justify-center rounded-full border border-white/10 text-white/40 hover:border-[#BEB0A0] hover:text-[#BEB0A0] transition-all cursor-pointer"
                >
                  <i className={s.icon} />
                </a>
              ))}
            </div>
          </div>

          {/* Right — links */}
          <div className="grid grid-cols-3 gap-6">
            {[
              { titleKey: "footer.servicesTitle", links: serviceLinks },
              { titleKey: "footer.companyTitle", links: companyLinks },
              { titleKey: "footer.resourcesTitle", links: resourceLinks },
            ].map((col) => (
              <div key={col.titleKey}>
                <h4 className="text-[10px] font-semibold uppercase tracking-widest text-white/25 mb-4">
                  {t(col.titleKey)}
                </h4>
                <ul className="flex flex-col gap-2.5">
                  {col.links.map((l) => (
                    <li key={l.labelKey}>
                      <Link to={l.path} className="text-sm text-white/45 hover:text-[#BEB0A0] transition-colors">
                        {t(l.labelKey)}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>

        <div className="pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-white/25 text-xs">
            &copy; {new Date().getFullYear()} {t("footer.copyright")}
          </p>
          <div className="flex gap-6">
            {[{ key: "footer.privacy" }, { key: "footer.terms" }, { key: "footer.disclaimer" }].map((l) => (
              <a key={l.key} href="/" rel="nofollow" className="text-xs text-white/25 hover:text-white/50 transition-colors">
                {t(l.key)}
              </a>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
}
